export function setLoading(state, loading) {
    state.loading = loading
}
export function setAccountReportResultEri(state, account_report){
    state.account_report = account_report
}
export function setMontsFields(state, monts_fields){
    state.monts_fields = monts_fields
}




// WEBPACK FOOTER //
// ./src/modules/report-reult-eri/mutations.js